import { createSlice } from '@reduxjs/toolkit';

// Define the reducer logic for 'twoSlice'
const customCategorySlice = createSlice({
  name: 'categoryState',
  initialState: {
    categoryData: [],
    showProduct: 'category'
  },
  reducers: {
    setCategoryData(state, action) {
      state.categoryData = action.payload;
    },
    setShowProductData(state, action) {
      state.showProduct = action.payload;
    },
  },
});

export const { setCategoryData , setShowProductData} = customCategorySlice.actions;

export default customCategorySlice;
